import { LockOutlined, MailOutlined } from "@ant-design/icons";
import { Button, Result } from "antd";
import React from "react";

const Blocked: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 transition-colors duration-300">
      <div className="max-w-md w-full px-6">
        <Result
          status="error"
          icon={
            <LockOutlined className="text-red-500 dark:text-red-400 text-6xl" />
          }
          title={
            <span className="text-gray-800 dark:text-white text-3xl font-bold">
              Tài khoản bị khóa
            </span>
          }
          subTitle={
            <div className="text-gray-600 dark:text-gray-300 text-base space-y-2">
              <p>Tài khoản của bạn đã bị khóa bởi quản trị viên.</p>
              <p>Vui lòng liên hệ bộ phận hỗ trợ để biết thêm chi tiết.</p>
            </div>
          }
          extra={
            <div className="space-y-3">
              <Button
                type="primary"
                size="large"
                icon={<MailOutlined />}
                className="w-full"
                style={{
                  backgroundColor: "var(--primary-color)",
                  borderColor: "var(--primary-color)",
                }}
                onClick={() =>
                  (window.location.href = "mailto:info@trace-tec.vn")
                }
              >
                Liên hệ hỗ trợ
              </Button>
            </div>
          }
        />

        <div className="text-center mt-2 space-y-3">
          <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg p-4">
            <p className="text-yellow-800 dark:text-yellow-200 text-sm font-medium">
              Lý do có thể bao gồm:
            </p>
            <ul className="text-yellow-700 dark:text-yellow-300 text-sm mt-2 space-y-1 text-left list-disc list-inside">
              <li>Vi phạm chính sách sử dụng</li>
              <li>Hoạt động bất thường được phát hiện</li>
              <li>Yêu cầu từ quản trị viên</li>
            </ul>
          </div>

          <p className="text-gray-500 dark:text-gray-400 text-xs">
            © 2025 Trace-Tec. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Blocked;
